var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[_c('b-container',{staticClass:"mb-6 mt-6",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('div',{staticClass:"card card-custom gutter-b",attrs:{"id":"wrapper"}},[_c('div',{staticClass:"card-body mt-0"},[_vm._t("default")],2)])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }